/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Alert/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function Alert({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardCreate/Alert",
  onChange,
  isSubmitting
  
}) {
let txCardFieldDefinitionAlertValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'alert',
})
let txCardFieldDefinitionAlertChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'alert',
})
let txCardFieldDefinitionAlertIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Alert"
 data="tx_card_field_definition.alert"
 value={txCardFieldDefinitionAlertValueData}
 onChange={txCardFieldDefinitionAlertChangeData}
 disabled={txCardFieldDefinitionAlertIsSubmittingData}
/>
{children}
</React.Fragment>)
}